export default __webpack_public_path__ + "static/Economic Model Whitepaper - English-e96fc94e0c6d4112748f28fa17f11cef.pdf";